import React from "react"
import { message } from "antd"

const style={
    marginTop: 20,
}

export default class Message {
    static open(msg) {
        message.open({
            content: <span style={{marginRight: "5px"}}>{msg}</span>,
            style:style,
            duration: 5
        })
    }

    static success(msg) {
        message.success({
            content: <span style={{marginRight: "5px"}}>{msg}</span>,
            style:style,
            duration: 5
        })
    }

    static warning(msg) {
        message.warning({
            content: <span style={{marginRight: "5px"}}>{msg}</span>,
            style:style,
            duration: 5
        })
    }

    static info(msg) {
        message.info({
            content: <span style={{marginRight: "5px"}}>{msg}</span>,
            style:style,
            duration: 5
        })
    }

    static error(msg) {
        message.error({
            content: <span style={{marginRight: "5px"}}>{msg}</span>,
            style:style,
            duration: 5
        })
    }
}
